// 診断セクション キーワード ↔ 商品ID マッピング

export const diagnosisKeywords = [
	// 種別
	{ id: 'nocolor', label: '無色リップ', products: ['medicated-regular', 'medicated-sensitive', 'botanical', 'extra-moisture'] },
	{ id: 'color', label: 'カラーリップ', products: ['sheer-orange-beige', 'sheer-brown-beige', 'sheer-rose-pink', 'sheer-red', 'sheer-bordeaux'] },
	{ id: 'medicated', label: '薬用リップ', products: ['medicated-regular', 'medicated-sensitive'] },
	{ id: 'uv', label: 'UVカット', products: ['sheer-orange-beige', 'sheer-brown-beige', 'sheer-rose-pink', 'sheer-red', 'sheer-bordeaux'] },

	// 保湿タイプ
	{ id: 'strong-moist', label: 'しっかり保湿', products: ['medicated-regular', 'extra-moisture'] },
	{ id: 'light-moist', label: 'さらりと保湿', products: ['botanical'] },
	{ id: 'sensitive', label: '敏感肌', products: ['medicated-sensitive'] },
	{ id: 'aging', label: 'エイジング', products: ['extra-moisture'] },

	// 肌タイプ
	{ id: 'yellow-base', label: 'イエベにおすすめ', products: ['sheer-orange-beige', 'sheer-brown-beige', 'sheer-red'] },
	{ id: 'blue-base', label: 'ブルベにおすすめ', products: ['sheer-rose-pink', 'sheer-bordeaux'] },

	// 系統色
	{ id: 'beige', label: 'ベージュ系リップ', products: ['sheer-orange-beige', 'sheer-brown-beige'] },
	{ id: 'red', label: 'レッド系リップ', products: ['sheer-red', 'sheer-bordeaux'] },
	{ id: 'pink', label: 'ピンク系リップ', products: ['sheer-rose-pink'] },

	// 印象
	{ id: 'gorgeous', label: 'ぱっと華やか', products: ['sheer-orange-beige', 'sheer-rose-pink', 'sheer-red'] },
	{ id: 'mature', label: '大人っぽく', products: ['sheer-brown-beige', 'sheer-bordeaux'] },

	// 発色
	{ id: 'bright', label: '明るい発色', products: ['sheer-orange-beige', 'sheer-rose-pink', 'sheer-red'] },
	{ id: 'deep', label: '深みのある発色', products: ['sheer-brown-beige', 'sheer-bordeaux'] },
];

export default diagnosisKeywords;
